export default {"src":"/_next/static/media/home-topbar-bg.5427e4fd (1).39704cd9.svg","height":578,"width":1920,"blurWidth":0,"blurHeight":0};